<div class="d-flex flex-column justify-content-between max-view-height">
    <div class="container">
        <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>

        <table class="table table-hover table-last-col table-add-row">
            <thead>
                <tr>
                    <th>Bedrijfsnaam</th>
                    <th>Platformnaam</th>
                    <th>Status</th>
                    <th class="text-end">SSL vervaldatum</th>
                    <th>Productie-URL</th>
                    <th>Acceptatie-URL</th>
                    <th>Test-URL</th>
                    <th>Local-URL</th>
                </tr>
            </thead>
            <tbody>
                @for (platform of sortedPlatforms(); track platform.id) {
                    <tr>
                        <td><a class="text-dark" routerLink="/{{Routenames.companies}}/{{platform.company?.id}}">{{platform.company?.name}}</a></td>
                        <td><a class="text-dark" routerLink="/{{Routenames.seire}}/{{platform.id}}">{{platform.name}}</a></td>
                        <td class="pb-0 pt-1">
                            <div class="d-flex gap-2">
                                @for (levelEnum of levelEnums; track levelEnum) {
                                    <div
                                        [class]="levelEnum | PlatformLevelStatusPipe: platform"
                                        [ngbTooltip]="levelEnum"
                                        [queryParams]="{level: levelEnum}"
                                        class="curpoint"
                                        routerLink="/{{Routenames.seire}}/{{platform.id}}">
                                    </div>
                                }
                            </div>
                        </td>
                        <td [class]="(platform.closest_ssl_expiry_date | minDate : platform.closest_acceptance_ssl_expiry_date) | sslValidUntil" class="text-end">
                            {{((platform.closest_ssl_expiry_date | minDate : platform.closest_acceptance_ssl_expiry_date) | daysFromNow) ?? '-'}}
                        </td>
                        <td><a [href]="platform.prod_url" class="platform-urls" target="_blank">{{platform.prod_url | urlPrefixStripping}}</a></td>
                        <td><a [href]="platform.acc_url" class="platform-urls" target="_blank">{{platform.acc_url | urlPrefixStripping}}</a></td>
                        <td><a [href]="platform.test_url" class="platform-urls" target="_blank">{{platform.test_url | urlPrefixStripping}}</a></td>
                        <td><a [href]="platform.local_url" class="platform-urls" target="_blank">{{platform.local_url | urlPrefixStripping}}</a></td>
                    </tr>
                } @empty {
                    <tr>
                        <td class="text-center" colspan="99">
                            @if (platforms() === null) {
                                Aan het laden...
                            } @else {
                                Geen platformen gevonden
                            }
                        </td>
                    </tr>
                }
                @if (Features.PlatformsSave | hasFeature) {
                    <tr>
                        <td colspan="99">
                            <button class="w-100 btn btn-secondary" routerLink="/{{Routenames.platforms}}/new">
                                Platform toevoegen <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    <div class="container">
        <table class="table table-hover table-last-col table-add-row">
            <thead>
                <tr>
                    <th class="text-end">Server IP</th>
                    <th>Server name</th>
                    <th class="text-end">Apache</th>
                    <th>Apache module</th>
                    <th class="text-end">Apache php</th>
                    <th class="text-end">Os</th>
                    <th class="text-end">Php</th>
                    <th class="text-end">Mysql</th>
                    <th class="text-end">Updates</th>
                    <th class="text-end">Last updated</th>
                </tr>
            </thead>
            <tbody>
                @for (server of servers(); track server.ip) {
                    <tr>
                        <td class="text-end">{{server.ip}}</td>
                        <td>{{server.server_name}}</td>
                        <td class="text-end">{{server.apache}}</td>
                        <td>{{server.apache_module}}</td>
                        <td class="text-end">{{server.apache_php}}</td>
                        <td class="text-end">{{server.os}}</td>
                        <td class="text-end">{{server.php}}</td>
                        <td class="text-end">{{server.mysql}}</td>
                        <td class="text-end">{{server.updates}}</td>
                        <td [class.text-danger]="isOlderThan2Days(server.updated_at)" class="text-end">{{server.updated_at | date:'EEE d MMM HH:mm'}}</td>
                    </tr>
                } @empty {
                    <tr>
                        <td colspan="99">Geen servers beschikbaar</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
